





































































































































































































































































































































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";

import Vue from "vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import CashOutView from "@/modules/cashStatement/CashOutView/models/CashOutView";
import { FilteringModel } from "@/services/filtering";
import CheckBox from "@/components/CheckBox.vue";
import cashStatementStore from "@/modules/cashStatement/services/store";
import pStore, {
  PaymentModeStore,
} from "@/modules/paymentMode/services/PaymentModeStore";
import configuration, { AppConfiguration } from "@/models/Configuration";
import PartnerSearch from "@/modules/partner/views/PartnerSearch.vue";
import Partner from "@/modules/partner/models/Partner";
import eventBus from "@/services/eventBus";
import dayjs from "dayjs";
import InterfaceApi from "@/modules/interface/services/InterfaceApi";
import { Iface } from "@/modules/interface/models/Iface";
import { IfaceType } from "@/modules/interface/models/IfaceType";

interface Data {
  filter: FilteringModel;
  sum: number;
  items: CashOutView[];
  selectedItems: CashOutView[];
  pStore: PaymentModeStore;
    configuration: AppConfiguration;
  addAll: boolean;
  selectedPartner: number;
  incadeaSyncAvailable: boolean;
}

interface Props {
  extraFilter: FilteringModel;
  partnerId: number;
  currency: string;
  isOverpay: boolean;
  cashDocByReceipts: boolean;
  title: string;
  isOutgoingDocument: boolean;
  noPadding: boolean;
  noActionsColor: boolean;
  showPartnerSearch: boolean;
}

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
}

interface Methods {
  selected(item: CashOutView): void;
  showDetails(item: CashOutView): void;
  addToSummary(dataItem: CashOutView): void;
  setItems(items: CashOutView[]): void;
  addItems(): void;
  createNewIncomingInvoice(): void;
  selectAllItems(): void;
  refresh(): void;
  partnerSelected(partner: Partner): void;
  syncInvoicesFromInterface(): void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ApiSearchPage, CheckBox, PartnerSearch },

  props: {
    extraFilter: { type: Object as () => FilteringModel },
    partnerId: { type: Number, default: 1 },
    currency: { type: String, default: "" },
    isOverpay: { type: Boolean, default: false },
    cashDocByReceipts: { type: Boolean, default: false },
    title: { type: String, default: "Számlaválogató" },
    isOutgoingDocument: { type: Boolean, default: false },
    noPadding: {type: Boolean, default: false},
    noActionsColor: {type: Boolean, default: false},
    showPartnerSearch: {type: Boolean, default: false},
  },

  data: () => ({
    filter: new FilteringModel(),
    sum: 0,
    items: [],
    selectedItems: [],
    pStore,
    addAll: false,
    configuration,
    selectedPartner: 1,
    incadeaSyncAvailable: false,
  }),

  async beforeMount() {
    this.filter = new FilteringModel();
    if (this.$props.extraFilter)
      this.filter = this.filter.fromFilter(this.$props.extraFilter.toObject());
    if (this.pStore.paymentModes.length < 2) {
      await this.pStore.loadPaymentModesWithoutBusy();
    }

    this.selectedPartner = this.$props.partnerId;

    // A szinkron gomb csak akkor aktív, ha az Incadea interfész él (cssysisynciface: live_dead).
    const interfaces = await InterfaceApi.getLiveInterfaces();
    this.incadeaSyncAvailable = interfaces.some((i) => i.id === Iface.Incadea);
  },

  methods: {
    /**
     * Számlák szinkronizálása az Incadea interfészről. A szinkron hívás és az azt követő
     * lista frissítés egyetlen busy indicator alatt fut.
     */
    async syncInvoicesFromInterface() {
      try {
        eventBus.$emit("busy-message", true);

        await InterfaceApi.downSync(
          dayjs().startOf("day").toDate(),
          new Date(),
          Iface.Incadea,
          IfaceType.None
        );

        this.refresh();
      } catch (ex) {
        console.log(ex);
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },

    partnerSelected(partner: Partner){
      this.refresh();
    },

    refresh(){
      const childComponentInstance = this.$refs.asref;
      if (childComponentInstance) {
        (this.$refs.asref as any).refreshClick();
      }
    },

    selectAllItems(){
      // Csak az aktuális oldal sorait jelöli ki/veszi le, a más oldalakon
      // korábban kiválasztott számlák megmaradnak.
      this.addAll = !this.addAll;

      if (this.addAll) {
        this.items.forEach(x => {
          if (x.lockAction.length == 0 && !x.added) {
            this.addToSummary(x);
          }
        });
      } else {
        this.items.forEach(x => {
          if (x.added) {
            this.addToSummary(x);
          }
        });
      }
    },

    createNewIncomingInvoice() {
      //this.$router.push("/general-incoming-invoice/create");
      if (this.configuration.invoiceFlow.enabled) {
        this.$router.push(`/general-incoming-invoice/flow/create/1`);
      }
      else {
        this.$router.push(`/general-incoming-invoice/create`);
      }
      this.$route.meta.isPictureRequired = false
    },

    async addItems() {
      if (!this.cashDocByReceipts) {
        await cashStatementStore.loadCashDocItemsByDocumentId(
          cashStatementStore.cashDocument.id
        );
      }

      this.$emit("add-selected-items", this.selectedItems);
    },

    selected(item: CashOutView) {
      this.$emit("selected", item);
    },

    showDetails(item: CashOutView) {
      item.selected = !item.selected;
    },

    addToSummary(dataItem: CashOutView) {
      // A selectedItems-et azonnal, közvetlenül karbantartjuk: a korábbi
      // get-items eventbus kör csak a KÖVETKEZŐ eseménynél vette fel a most
      // kijelölt számlát, így lapozáskor/szűréskor az utolsó kijelölés elveszett.
      if (!dataItem.added) {
        dataItem.added = true;
        const alreadySelected = this.selectedItems.some(
          (x) => x.invNo === dataItem.invNo && x.code === dataItem.code
        );
        if (!alreadySelected) {
          this.selectedItems.push(dataItem);
        }
      } else {
        dataItem.added = false;
        this.selectedItems = this.selectedItems.filter(
          (x) => !(x.invNo === dataItem.invNo && x.code === dataItem.code)
        );
      }
      this.sum = this.selectedItems.reduce((acc, x) => acc + x.toPayment, 0);
      this.$emit("update-sum", this.sum);
    },

    setItems(items) {
      this.items = items;
      const newSelected = items.filter((x) => x.added);
      newSelected.forEach((element) => {
        // Stabil üzleti kulcs (invNo + code) szerint dedupolunk, nem objektum-
        // referencia szerint: minden lekérdezés (lapozás/szűrés/rendezés) új
        // objektumokat ad vissza, így a referencia-egyezés nem ismerné fel az
        // ugyanazt a számlát, és duplikátumként kerülne a kiválasztottak közé.
        const alreadySelected = this.selectedItems.some(
          (x) => x.invNo === element.invNo && x.code === element.code
        );
        if (!alreadySelected) {
          this.selectedItems.push(element);
        }
      });

      // Lapozás/szűrés után a frissen letöltött sorokon visszajelöljük a
      // korábban kiválasztott számlákat, és a selectedItems-ben a régi
      // objektumot a megjelenített frissre cseréljük, hogy a sorban végzett
      // további szerkesztés (pl. végszámla megjegyzés) a mentett tételen is
      // érvényesüljön.
      this.selectedItems = this.selectedItems.map((sel) => {
        const fresh = items.find(
          (x) => x.invNo === sel.invNo && x.code === sel.code
        );
        if (fresh && fresh !== sel) {
          fresh.added = true;
          fresh.finalRemark = sel.finalRemark;
          return fresh;
        }
        return sel;
      });

      const selectable = items.filter((x) => x.lockAction.length == 0);
      this.addAll =
        selectable.length > 0 && selectable.every((x) => x.added);

      this.sum = this.selectedItems.reduce((acc, x) => acc + x.toPayment, 0);
      this.$emit("update-sum", this.sum);
    },
  },

  computed: {
    columns: function() {
      return this.cashDocByReceipts
        ? [
            {
              cell: "detailsButton",
              filterable: false,
              header: 'allSelect'
            },
            //{ field: "prefix", title: "Prefix", headerClass: "prefix-column" },
            { field: "maskedInvNo", title: "Számlaszám" },
            { field: "partner", title: "Partner" },
            {
              field: "pmode",
              title: "Fizetési mód",
              multiselect: true,
              multiselectField: "pmodes",
              multiselectOptions: this.pStore.paymentModes.map((x) => ({
                text: x.name,
                value: x.id,
              })),
              multiselectSelect: this.pStore.paymentModes
                .filter((x) => x.name === "Készpénz" || x.name === "Bankkártya")
                .map((x) => x.id),
            },
            {
              cell: "currNetto",
              field: "currNetto",
              title: "Nettó (a számla pénznemében)",
              type: ColumnType.Money,
            },
            {
              cell: "currTotal",
              field: "currTotal",
              title: "Bruttó (a számla pénznemében)",
              type: ColumnType.Money,
            },
            {
              cell: "exchangeRate",
              field: "exchangeRate",
              width: 150,
              visible: this.$props.currency != "HUF",
              title: "Számlán szereplő árfolyam",
              type: ColumnType.Money,
            },
            {
              cell: "netto",
              field: "netto",
              visible: this.$props.currency != "HUF",
              title: "Nettó (a pénztár pénznemében)",
              type: ColumnType.Money,
            },
            {
              cell: "total",
              field: "total",
              visible: this.$props.currency != "HUF",
              title: "Bruttó (a pénztár pénznemében)",
              type: ColumnType.Money,
            },
            {
              cell: "toPayment",
              field: "toPayment",
              title: "Szla. nyitott rész",
              type: ColumnType.Money,
              sortable: false,
              filterable: false,
            },
            { field: "remark", title: "Megjegyzés", fieldClass: "note-column" },
            { field: "finalRemark", title: "Végszámla megjegyzés", cell: 'finalRemark', filterable: false, sortable: false },
          ]
        : [
            {
              cell: "detailsButton",
              filterable: false,
              header: 'allSelect'
            },
            //{ field: "prefix", title: "Prefix", headerClass: "prefix-column" },
            { field: "maskedInvNo", title: "Számlaszám" },
            { field: "partner", title: "Partner" },
            {
              field: "pmode",
              title: "Fizetési mód",
              multiselect: true,
              multiselectField: "pmodes",
              multiselectOptions: this.pStore.paymentModes.map((x) => ({
                text: x.name,
                value: x.id,
              })),
            },
            {
              cell: "currNetto",
              field: "currNetto",
              title: "Nettó (a számla pénznemében)",
              type: ColumnType.Money,
            },
            {
              cell: "currTotal",
              field: "currTotal",
              title: "Bruttó (a számla pénznemében)",
              type: ColumnType.Money,
            },
            {
              cell: "exchangeRate",
              field: "exchangeRate",
              width: 150,
              visible: this.$props.currency != "HUF",
              title: "Számlán szereplő árfolyam",
              type: ColumnType.Money,
            },
            {
              cell: "netto",
              field: "netto",
              visible: this.$props.currency != "HUF",
              title: "Nettó (a pénztár pénznemében)",
              type: ColumnType.Money,
            },
            {
              cell: "total",
              field: "total",
              visible: this.$props.currency != "HUF",
              title: "Bruttó (a pénztár pénznemében)",
              type: ColumnType.Money,
            },
            {
              cell: "toPayment",
              field: "toPayment",
              title: "Szla. nyitott rész",
              type: ColumnType.Money,
              filterable: false,
              sortable: false,
            },
            { field: "remark", title: "Megjegyzés", fieldClass: "note-column" },
            { field: "finalRemark", title: "Végszámla megjegyzés", cell: 'finalRemark', filterable: false, sortable: false },
          ];
    },

    url() {
      return this.$props.cashDocByReceipts
        ? `cash-flow/out/dto/search/cashdocbyreceipts/${this.$props.currency}`
        : `cash-flow/out/dto/search/${this.$props.isOverpay}/${this.selectedPartner}/${this.$props.currency}`;
    },
  },
});
